import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial, useStylesAutoBlack,
} from '../../../../St/Reports/UseStyle';

import { useTranslation } from "react-i18next";
import { SaleCheckbox } from '../../../../St/comps/UseStyle';
import { FormControlLabel } from '@material-ui/core';

export default function VatReportsOneForm(props) {

    const {
        type,
        rptParams,
        onChangeData,
        onChangeAutoData,
        AutoOptions,
        typeSearch,
        showtab3vat,
        setShowtab3vat
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAutoBlack();
    const clasTF = useStylesTF();
    const { t } = useTranslation(["forms", "translation"]);

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>

                <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="datef"
                        label="من تاريخ"
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        type="date" format="YYYY-MM-DD"
                        name="dateFrom" value={rptParams.dateFrom}
                        onChange={onChangeData("dateFrom")} />
                </Grid>
                <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="datef"
                        label="الى تاريخ"
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        type="date" format="YYYY-MM-DD"
                        name="dateTo" value={rptParams.dateTo}
                        onChange={onChangeData("dateTo")} />
                </Grid>


                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={rptParams.branch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("branch", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={AutoOptions?.Branches}
                        style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        renderInput={(params) => (
                            <TextField
                                id="user"
                                {...params}
                                label={"الفرع"}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            />
                        )}
                    />

                </Grid>


                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={rptParams.typeSearch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("typeSearch", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={typeSearch}
                        style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        renderInput={(params) => (
                            <TextField
                                id="center"
                                {...params}
                                label={"عرض حسب"}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            />
                        )}
                    />

                </Grid>
                <Grid item lg={1} md={2} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <FormControlLabel
                        id="showPaid"
                        value="addProfSalary"
                        name="showPaid"
                        className={claslbl.clor}
                        control={
                            <SaleCheckbox
                                checked={showtab3vat}
                                onChange={(e) => {
                                    setShowtab3vat(e.target.checked);
                                }}
                                color={"#f18584"}
                            />
                        }
                        label={t("tobacco_tax")}
                        labelPlacement="end"
                    />
                </Grid>

            </Grid>

        </React.Fragment>

    );

}